import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { GoogleButton } from "@/pages/Login";

export default function Register() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "traveler", phone: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data.user);
      navigate(data.user.role === "host" ? "/espace-hote" : "/mes-sejours");
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md fade-up">
        <div className="flex items-center gap-2 mb-6">
          <Logo size={40} />
          <span className="font-serif text-2xl text-olive">L’Orne Park</span>
        </div>
        <h1 className="font-serif text-4xl text-olive">Créer un compte</h1>
        <p className="text-muted-foreground mt-1 mb-6">Rejoignez notre maison</p>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <Label>Nom complet</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-1 h-11" data-testid="register-name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1 h-11" data-testid="register-email" />
          </div>
          <div>
            <Label>Téléphone (pour les infos de séjour par SMS)</Label>
            <Input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+33 6 12 34 56 78" className="mt-1 h-11" data-testid="register-phone" />
          </div>
          <div>
            <Label>Mot de passe</Label>
            <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="mt-1 h-11" data-testid="register-password" />
          </div>
          <div>
            <Label>Je suis</Label>
            <div className="grid grid-cols-2 gap-3 mt-1">
              {[["traveler", "Voyageur"], ["host", "Hôte / Équipe"]].map(([v, label]) => (
                <button key={v} type="button" onClick={() => setForm({ ...form, role: v })}
                  className={`h-11 rounded-xl border text-sm font-medium transition-colors ${form.role === v ? "border-rose-brand bg-rosebrand-pale text-rose-brand" : "border-border text-muted-foreground"}`}
                  data-testid={`register-role-${v}`}>
                  {label}
                </button>
              ))}
            </div>
          </div>
          {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full h-11 bg-rose-brand hover:bg-rosebrand-soft text-white" data-testid="register-submit">
            {busy ? "Création..." : "Créer mon compte"}
          </Button>
        </form>
        <div className="flex items-center gap-3 my-5"><div className="flex-1 h-px bg-border" /><span className="text-xs text-muted-foreground">OU</span><div className="flex-1 h-px bg-border" /></div>
        <GoogleButton />
        <p className="text-sm text-center text-muted-foreground mt-6">
          Déjà membre ? <Link to="/connexion" className="text-rose-brand font-semibold">Connectez-vous</Link>
        </p>
      </div>
    </div>
  );
}
